
    import { store } from '@/stores/Store';
    import Vue from 'vue';
    import { TabService } from "@/services/TabService"
import { mapGetters } from 'vuex';

    export default Vue.extend({
        created() {
            TabService.showTabs();
        },
    methods: {
        toggleTabs(): void {
            if (this.showTabs as boolean) {
                TabService.hideTabs();
            } else {
                TabService.showTabs();
            }

            console.log(`Is tabs visible: ${TabService.isTabsVisible()}`);
        }
    },
    computed: {
        showTabs: () => {
            return store.getters.showTabs;
        },
        ...mapGetters([
            "isSystemAdmin",
            "isMunicipalityAdmin",]),
    }
})
